import { useTranslation } from '@mc/i18n'
import { TrackingContainer } from '@mc/visibility'

import { trackValuePropViewed } from 'components/ValueProps'
import { ProductExplainer } from 'components/ProductExplainer'

import { trackCatalogPageRowViewed } from '../../events'
import { usePageData } from '../PageDataProvider'

export const WhatYouGet = () => {
  const { t } = useTranslation('@mc/next')

  const { slug } = usePageData()

  return (
    <div className='container mc-my-8'>
      <TrackingContainer
        onFirstVisible={() => {
          trackCatalogPageRowViewed({
            rowName: 'subscription_benefits_section',
            categorySlug: slug,
          })
          trackValuePropViewed()
        }}
        config={{
          threshold: 0.4,
          duration: { visible: 500 },
        }}
      >
        <ProductExplainer
          titleOverride={
            <div className='d-flex flex-column align-items-center mc-mb-8'>
              <h2 className='mc-text-h2'>
                {t('categories.categoryPage.whatYouGet.title')}
              </h2>
              <div className='mc-mb-4' />
              <h3 className='mc-text-large mc-text--light'>
                {t('categories.categoryPage.whatYouGet.subtitle')}
              </h3>
            </div>
          }
        />
      </TrackingContainer>
    </div>
  )
}
